// @flow

import React from 'react';
import { RichText } from 'components/Text';
import type { RichTextBlockData } from 'api/cms';

const RichTextBlock = ({
  data: { html },
  fullWidthLayout,
  isSidebar
}: {
  data: RichTextBlockData,
  fullWidthLayout?: boolean,
  isSidebar?: boolean
}) => (
  <RichText
    dangerouslySetInnerHTML={{ __html: html }}
    textAlign={fullWidthLayout && 'center'}
    small={isSidebar}
    requestIsAmp
  />
);

export default RichTextBlock;
